import { NgModule } from '@angular/core';

import { MiraService } from '@common/mira/mira.service';

@NgModule({
    declarations: [],
    imports: [],
    exports: [],
    providers: [
        MiraService
    ]
})

export class MiraModule { }
